import { Code404 } from '@components/error/code-404';
import { Code500 } from '@components/error/code-500';
import { CodeXXX } from '@components/error/code-XXX';

import type { ComponentType } from 'svelte';

export function getErrorComponent(code: number | undefined): ComponentType {
    switch (code) {
        case 404:
            return Code404;
        case 500:
            return Code500;
        default:
            return CodeXXX;
    }
}
